import React, { useContext, useEffect, useState } from "react";
import { Table, Button, Breadcrumb } from "antd";
import { AccRequest } from "../../../core/interfaces/AccRequest";
import { format } from "date-fns";
import { useNavigate, useLocation } from "react-router-dom";

import {
  statusDescriptions,
  actionDescriptions,
} from "../../../utilities/constants";
import "./SearchResults.css";
import {
  AccRequestDetailContextType,
} from "../../../context/account-req-detail";
import { appInsights } from "../../../core/services/insight.service";
import GlobalErrorMessage from "../../global-error/GlobalErrorMessage";
import { UserContext } from "../../../context/user-context";

interface SearchResultsProps {
  data: AccRequest[];
  srcType: string;
}
const getStatusDescription = (status: number): string => {
  return statusDescriptions[status] || "Unknown Status";
};

const getActionDescription = (code: string): string => {
  if (!code) return "Unknown";
  const upperCode = code.toUpperCase().trim();
  return actionDescriptions[upperCode] || "Unknown";
};

const SearchResults: React.FC = () => {
  const location = useLocation();
  const [apiError, setApiError] = useState(null);
  const navigate = useNavigate();
  const { contextValue } = location.state;
  const user = useContext(UserContext);
  

  const [reqType , setReqType] = useState<string>('');
  useEffect(() => {setReqType(contextValue.srcType)}, [reqType]);

  const handleOnClickReqNumner = (requestID: number, status: number) => {
    const contextValue = {
      requestNumber: requestID.toString(),
      reqType: reqType,
      status: status.toString(),
      frompending:false,
      userEmail : user.email,
    };
    try {
      navigate(`/manage requests/request-detail?requestNumber=${contextValue.requestNumber}&reqType=${contextValue.reqType}&frompending=${contextValue.frompending}&userEmail=${contextValue.userEmail}`);

    

    } catch (error) {
      setApiError(error);
      appInsights.trackEvent({ name: "NavigationFailed", properties: { error: error } });
    }
  };

  const columns = [
    {
      title: "",
      dataIndex: "index",
      key: "index",
      render: (_: any, __: AccRequest, index: number) => index + 1,
      width: 30,
    },
    {
      title: "Request",
      dataIndex: "requestID",
      key: "requestID",
      render: (_: any, record: AccRequest) => (
        <div>
          <b>Requester:</b> <span className="person">{record.requester}</span>
          <br />
          <b>Request ID:</b>{" "}
          <Button
            variant="link"
            onClick={() =>
              handleOnClickReqNumner(record.requestID, record.status || 0)
            }
            style={{
              background: "none",
              border: "none",
              padding: 0,
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {record.requestID}
          </Button>
          <br />
          <b>Request:</b> {getActionDescription(record.actioncCode)}{" "}
          {contextValue.srcType}
        </div>
      ),
    },
    {
      title: "Request Date",
      dataIndex: "requestDate",
      key: "requestDate",
      width: 100,
      render: (date: string) => format(new Date(date), "M/d/yyyy"), // Format the date
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 250,
      render: (status: number) => getStatusDescription(status),
    },
  ];
  const handleRetry = () => {
    setApiError(null);
  };
  return (
    <>
     {apiError ? (
          <GlobalErrorMessage 
          error={apiError}
          visible={!!apiError}
          onClose={() => setApiError(null)}
          onRetry={handleRetry}
        />
        ) : (
      <><Breadcrumb
            items={[
              {
                title: "/search results",
              },
            ]} /><div className="div-container">
              <Table


                dataSource={contextValue.accRequest || []}

                columns={columns}


                rowKey="requestID"
                pagination={false}
                bordered={true}
                size="small"
                rowClassName={() => "white-background-row"}
                style={{ marginTop: "30px" }}
                locale={{
                  emptyText: (
                    <div>
                      <p>No records found.</p>
                    </div>
                  ), // Enhanced empty state message
                }} />
            </div><Button
              type="default"
              style={{ marginLeft: "10px" }}
              onClick={() => window.history.back()}
            >
              Back
            </Button></>
        )}
    </>
  );
};

export default SearchResults;
